// extracted by mini-css-extract-plugin
export default {"wrapper":"loading_wrapper__KkFLx","loader":"loading_loader__Oc2R3"};